<template>
    <div>
        <div v-if="previewing" class="PreviewableInput__preview" @click.stop="edit">
            <slot name="preview"></slot>
            <div class="p-l-sm">
                <button type="button" class="btn-inline">
                    <span class="fa fa-pencil"></span>
                </button>
            </div>
        </div>
        <div v-else class="flex v-center">
            <div v-click-outside="blurred" class="flex-1">
                <slot name="input" :input-events="inputEvents" :input-attrs="inputAttrs"></slot>
            </div>
            <!--
            <div class="p-l-sm">
                <button type="button" class="btn-inline" @click="cancel">
                    <span class="fa fa-undo"></span>
                </button>
            </div>
            -->
        </div>
    </div>
</template>

<style scoped type="text/less" lang="less">
@import '~dashboard-less/variables';
@import '~dashboard-less/spark/utilities';

.PreviewableInput__preview {
    @apply items-center;

    display: inline-flex;
    cursor: pointer;

    &:hover {
        background-color: fade(@brand-primary, 15%);
    }
}
</style>

<script type="text/babel">
import ClickOutside from 'dashboard-js/directives/ClickOutside'

export default {
    directives: {
        ClickOutside,
    },
    props: {
        form: {},
        field: {},
        closeOnBlur: {
            default: true,
        },
        canPreview: {
            default: true,
        },

        maxlength: {
            type: [Number, String],
            default: null,
        },
        maxValue: {
            type: Number,
            default: null,
        },
    },

    data() {
        return {
            originalValue: null,
            previewing: this.canPreview,
            inputEvents: {
                input: e => {
                    if (e !== null && typeof e === 'object' && typeof e.target !== 'undefined') {
                        return this.update(e.target.value)
                    }
                    this.update(e)
                },
                keydown: e => {
                    if (e.keyCode === 27) {
                        e.preventDefault()
                        this.cancel()
                    }
                },
            },
        }
    },

    computed: {
        inputAttrs() {
            const attrs = {
                value: this.value,
            }
            if (this.maxlength) {
                attrs.maxlength = this.maxlength
            }

            return attrs
        },

        value: {
            get() {
                return this.$get(this.form, this.field)
            },
            set(value) {
                this.$set(this.form, this.field, value)
            },
        },
    },

    watch: {
        canPreview(canPreview) {
            if (!canPreview && this.previewing) {
                this.edit()
            }
        },

        previewing(nowPreviewing) {
            if (!nowPreviewing) {
                this.originalValue = this.value

                Vue.nextTick(() =>
                    $(this.$el)
                        .find('input, textarea, select')
                        .select()
                )
            }
        },
    },

    created() {
        this.form.events.$on('success', () => {
            this.preview()
        })

        if (!this.canPreview) {
            this.originalValue = this.value
            this.edit()
        }
    },

    methods: {
        cancel() {
            if (this.value !== this.originalValue) {
                if (confirm('Du mister dine ændringer. Vil du fortsætte?')) {
                    this.update(this.originalValue)
                    this.form.errors.forget(this.field)
                    this.preview()
                }
                return
            }
            this.preview()
        },

        blurred() {
            if (this.value === this.originalValue && this.closeOnBlur) {
                this.preview()
            }
        },

        edit() {
            this.previewing = false
            this.$emit('edit')
        },

        preview() {
            if (this.canPreview) {
                this.previewing = true
                this.$emit('preview')
            }
        },

        update(value) {
            // Set the value to the max if it's greater than the max
            if (this.maxValue !== null && value > this.maxValue) {
                value = this.maxValue
            }

            this.value = value
        },
    },
}
</script>
